import { Space, Spin, Typography } from 'antd'
import { alphabeticalSort } from 'shared'
import HelpIcon from '../HelpIcon'
import { CIMSTag } from '../CIMSTag'
import { CIMSTagsProps } from './types'

/**
 * renders a list of {@link CIMSTag} components with an optional header
 *
 * @param {@link CIMSTagProps}
 */
export const CIMSTags: React.FC<CIMSTagsProps> = ({
  tags = [],
  header,
  direction,
  noSort,
  loading,
}) => {
  if (!noSort) tags.sort(alphabeticalSort('text'))
  const tagSpace = (
    <Space
      size="small"
      direction={direction?.tags}
      wrap
      // this was here before... but seems to add an extra margin/space on the bottom...
      // i'll keep it here in case we find there's weird rendering without it
      // style={{ marginBottom: 0 }}
    >
      {tags.map(({ text, ...props }, i) => (
        <CIMSTag key={`${Math.random()}-${i}`} {...props}>
          {text}
        </CIMSTag>
      ))}
    </Space>
  )
  if (!header) return tagSpace
  const { help } = header
  const content =
    typeof header.content === 'string' ? (
      <Typography.Text>{header.content}</Typography.Text>
    ) : (
      header
    )
  return (
    <Spin size="small" spinning={loading ?? false}>
      <Space size="small" align="start" direction={direction?.header}>
        <HelpIcon text={help}>{content}</HelpIcon>
        {tagSpace}
      </Space>
    </Spin>
  )
}
